/*=========================================================================================
  File Name: modulePropertyCatgeory.js
  Description: PropertyCatgeory Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePropertyCatgeoryState.js'
import mutations from './modulePropertyCatgeoryMutations.js'
import actions from './modulePropertyCatgeoryActions.js'
import getters from './modulePropertyCatgeoryGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
